import React, { useEffect } from 'react';
import { Row, Col } from 'antd';

import Companies from 'views/Administration/DebtManagement/Companies';
import Individuals from 'views/Administration/DebtManagement/Individuals';
import useLastPathname from 'hooks/navigation/useLastPathname';
import Instructions from './Instructions';
import { useDispatch, useSelector } from 'react-redux';
import { getDebtId } from '../../../store/entities/administration/thunks';
import LoadingSpinner from 'components/reusable/LoadingSpinner';
import { SelectedDebtorSection } from './sections';
import SuccessModal from '../../../components/reusable/SuccessModal';
import { setSuccessModalVisible } from '../../../store/entities/administration';
import UploadDebtModal from './modals/UploadDebt';

const DebtManagement = () => {
  const lastPathname = useLastPathname();
  const dispatch = useDispatch();
  const { debtsExcelLoading, isSuccessModalVisible, successMsgType } = useSelector(state => state.administration);
  useEffect(() => {
    dispatch(getDebtId());
    return () => {
      dispatch({ type: 'REMOVE_SELECTED_DEBTOR' });
    };
  }, []);

  return (
    <LoadingSpinner size="large" spinning={debtsExcelLoading}>
      <div className="container">
        <Row>
          <Col span={24}>
            {(lastPathname === 'company' || lastPathname === 'individuals') && (
              <SelectedDebtorSection companyOrPerson={lastPathname} />
            )}
            {lastPathname === 'company' && <Companies />}
            {lastPathname === 'individuals' && <Individuals />}
            {lastPathname === 'instructions' && <Instructions />}
          </Col>
        </Row>
      </div>
      <SuccessModal
        onCancel={() => dispatch(setSuccessModalVisible(false))}
        isOpen={isSuccessModalVisible}
        debtManagement
        type={successMsgType}
      />
      <UploadDebtModal />
    </LoadingSpinner>
  );
};

export default DebtManagement;
